import React, { useContext } from 'react';
import SearchContext from '../data/FunnelbackContext';

/**
 * No Results Component
 *
 * @returns {JSX.Element}
 * @constructor
 */
function NoResults() {
    const {
        collection,
        resultsSummary: { query },
    } = useContext(SearchContext);

    return (
        <div className="funnelback-instant-search-no-results">
            <h3 className="funnelback-instant-search-no-results__title">No results</h3>
            <p>
                Your search for <strong>{query}</strong> did not return any results. Please ensure that you:
            </p>
            <ul>
                <li>are not using any advanced search operators like + - | &quot;&quot; etc.</li>
                <li>
                    expect this document to exist within the <em>{collection}</em> collection{' '}
                </li>
                <li>have permission to see any documents that may match your query</li>
            </ul>
        </div>
    );
}

export default NoResults;
